module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/artistry/makeover/font/glyphicons-halflings-regular.ttf
// module id = vPr3
// module chunks = 0